/* assets/product-features.js.liquid */
(function(window, document, utils) {
  'use strict';
  window.SDG = window.SDG || {};
  
  SDG.productFeatures = function() {
    var c = {
      dom: {
        carousel: 'js-features-carousel',
        features: 'pvFeatures',
        pencil: 'js-features-pencil',
        overlay: 'js-features-overlay',
        video: 'js-features-video',
        video_parent: 'featuresVideo',
        vid_image: 'js-vid-image',
        pdp_accordian: 'js-accordian-btn'
      },
      cls: {
        margin: 'remove-margin-top',
        z_index: 'remove-z-index',
        active: 'is-active',
        open: 'is-open'
      }
    };
    
    var $features = document.getElementById(c.dom.features);
    var $featuresVideo = document.querySelector('.' + c.dom.video);
    var $featuresVideoParent = document.getElementById(c.dom.video_parent);
    var $featuresCarousel = document.querySelector('.' + c.dom.carousel);
    var accordionButtons = document.querySelectorAll('.' + c.dom.pdp_accordian);
    var carousel = window.SDG.carousel ? window.SDG.carousel({ dom: { carousel: c.dom.carousel }, flickityOpts: { prevNextButtons: false } }) : null;
    
    function init() {
      if ($featuresVideoParent) {
        utils.addEvent({ id: c.dom.video_parent, className: c.dom.video, event: 'click', fn: togglePlay });
        if ($features) {
          utils.waypoint({ el: $features, in: setupVideo, offset: 100 });
        }
      }
      if ($featuresCarousel && carousel) carousel.init();
      if (accordionButtons) accordian();
    }
    
    function togglePlay() {
      if ($featuresVideo) {
        $featuresVideo.paused ? $featuresVideo.play() : $featuresVideo.pause();
      }
    }
    
    function setupVideo() {
      var pencilOutlines = document.querySelectorAll('.' + c.dom.pencil);
      var overlayImages = document.querySelectorAll('.' + c.dom.overlay);
      pencilOutlines.forEach(function(outline) {
        utils.addClass(outline, c.cls.z_index);
      });
      overlayImages.forEach(function(overlay) {
        utils.addClass(overlay, c.cls.margin);
      });
    }
    
    function accordian() {
      accordionButtons.forEach(function(button) {
        button.addEventListener('click', function() {
          button.classList.toggle(c.cls.active);
          var details = button.nextElementSibling;
          if (details) {
            details.classList.toggle(c.cls.open);
            if (details.classList.contains(c.cls.open)) {
              details.style.display = 'block';
              details.style.height = details.scrollHeight + 'px';
            } else {
              details.style.height = '0';
              setTimeout(function() { details.style.display = 'none'; }, 300);
            }
          }
        });
      });
    }
    
    init();
  };

})(window, document, window.utils);
